import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import HoverLinkBtn from "../../components/common/button/HoverLinkBtn";
import CustomTitle from "../../components/common/title/CustomTitle";
import { Redirect } from "react-router-dom";
import QuestionAccoItem from "../../components/cs/QustionAccoItem"
import { getConsultAction } from "../../modules/cs/customserviceModule"
import Pagination from '../../components/common/Pagination';
import { useHistory } from 'react-router-dom';
import queryString from "query-string";
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MySettingBlock = styled.div``;

const MySettingWrapBlock = styled.div`
${isMobileOnly?`
    margin: 0 4vw; 
    padding: 120px 0 120px;    
    `:`
    padding: 140px 0 120px;
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
    `};

    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const MySettingLnbBlock = styled.div`
    float: left;
    ${isMobileOnly?`
    width: 100%;     
  `:`
    width: 234px;
    padding-right: 40px;
  `};

    h2 {
        margin-bottom: 50px;
        font-size: 32px;
        font-weight: 700;
    }
`;

const MySettingLnbUlContainBlock = styled.div`
    ${isMobileOnly?`
    width: 100%;
    //overflow: scroll hidden; 
    overflow-x: scroll;
    overflow-y: hidden;  
    height: 35px;
    margin-bottom: 10vw;
    border-bottom: 1px solid #111; 
  `:`
    
  `};
`;

const MySettingLnbLiBlock = styled.li`
    margin-bottom: 30px;
    color: #333;
    font-size: 20px;
    font-weight: 500;

    ${isMobileOnly&&"float: left"};
    ${isMobileOnly&&"margin-right: 4vw"};
`;

const MyQuestionContentsBlock = styled.div`
    float: left;
    ${isMobileOnly?`
    width: 100%;
  `:`
    width: 936px;
  `};
`;

const MyQuestionAccoUlBlock = styled.ul`
    border-top: 2px solid #111;
    margin-bottom: 40px;
`;

const MySettingTableWrapBlock = styled.div`
    width: 100%;
    border-top: 2px solid #111
    margin-bottom: 50px;

    .dt-title {
        padding-bottom: 20px;
        font-size: 18px;
        font-weight: 700;
    }
`;

const MyQuestionNoItemBloc = styled.div`
    position: relative;
    height: 80px;
    border-top: 2px solid #111;
`;

const MyQuestionNoItemSpanBlock = styled.span`
    position: absolute;
    top: 70%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    color: #666;
    font-size: 16px;
`;

const MyQuestionButtonContainBlock = styled.div`
    text-align: center;
    margin-bottom: 40px;
    margin-top: 40px;
`;
const MyQuestionButtonBlock = styled.button``;

const CustomTitleBlock = styled.h2`
    margin-bottom: ${props => props.marginBottom || '40px'};
    margin-top: ${props => props.marginTop || '0px'};
    font-size: ${props => props.fontSize || '32px'};
    font-weight: ${props => props.fontWeight || '500'};
    text-align: ${props => props.textAlign || 'center'};
    color: ${props => props.textColor || '#fff'};
    padding: ${props => props.padding || '0px'};
    //height: ${props => props.fontSize || 'fontSize'};
    display : ${props => props.display || 'block'};
    height : ${props => props.height || 'fontSize'};
`;

const MyQuestion = ({ location }) => {

    const dispatch = useDispatch();
    const [curPage, setCurPage] = useState(1);
    const [totalCount, setTotalCount] = useState(-1);
    const history = useHistory();
    const [curSelId, setCurSelId] = useState(-1);

    const { loading, accessToken, id, listData } = useSelector(
        ({ userReducer, loadingReducer, customserviceReducer }) => ({
            registError: userReducer.registError,
            loading: loadingReducer['customservice/GET_CONSULT'],
            regStatus: userReducer.regStatus,
            accessToken: userReducer.accessToken,
            id: userReducer.id,
            listData: customserviceReducer.listData
        })
    );

    useEffect(() => {
        dispatch(setCurMenuAction('mp'));
        dispatch(setHeaderTransferAction(false));
        window.scrollTo(0, 0);
    }, []);


    useEffect(() => {

        if (accessToken !== null) {
            let query = queryString.parse(location.search);

            if (query === null || query.page === undefined) {
                dispatch(getConsultAction(id, 1));
            }
            else if (query !== null && query.page !== undefined && query.page !== null && query.page.length > 0) {
                setCurPage(parseInt(query.page));
                dispatch(getConsultAction(id, parseInt(query.page)));
                setCurSelId(-1);
            }
            else {
                dispatch(getConsultAction(id, 1));
            }
            //dispatch(getConsultAction(id, curPage));
            window.scrollTo(0, 0);
        }
    }, []);

    useEffect(() => {
        if (listData !== null) {
            setTotalCount(listData.count);
        }

    }, [listData]);

    const handleChangePageNum = (value) => {
        if(value === curPage){
            return;
        }
        /* setCurPage(value);
        setCurSelId(-1);
        dispatch(getConsultAction(id, value)); */
        let link = 'page='+value;
        history.push("/myquestion?" + link);
    }

    const handleQuestion = () => {
        history.push('/consult')
    }

    const handleAccBtn = (id) => {
        if (curSelId === id) {
            setCurSelId(-1);
        }
        else {
            setCurSelId(id);
        }
    }

    const menuTitle = [
        { title: '나의견적', link: '/es', isUnderLine: false },
        { title: '나의클립북', link: '/myclip', isUnderLine: false },
        { title: '회원정보관리', link: '/mysetting', isUnderLine: false },
        { title: '1:1 문의 내역', link: '/myquestion', isUnderLine: true }
    ];

    // 로그인 상태가 아니라면
    if (accessToken === null) {
        return <Redirect to="/" />
    }

    if (totalCount === -1) {
        return (
            <MySettingBlock>
                <Header />
                <MySettingWrapBlock>
                    <MySettingLnbBlock>
                        <h2>마이페이지</h2>
                        <MySettingLnbUlContainBlock>
                        <ul style = {isMobileOnly? {width:'max-content'}:{}}>
                            {
                                menuTitle.map((curitem, idx) => {
                                    return (
                                        <MySettingLnbLiBlock key={idx}>
                                            <HoverLinkBtn text={curitem.title}
                                                bottom="2px"
                                                height="4px"
                                                link={curitem.link}
                                                isDot={false}
                                                isUnderLine={curitem.isUnderLine}
                                            >
                                            </HoverLinkBtn>
                                        </MySettingLnbLiBlock>
                                    );
                                })
                            }
                        </ul>
                        </MySettingLnbUlContainBlock>
                    </MySettingLnbBlock>
                    <MyQuestionContentsBlock className="mypage-content">
                        <CustomTitle marginBottom="58px" textColor="#333"
                            fontSize="24px" fontWeight="300" title="1:1 문의 내역" textAlign="left" />


                    </MyQuestionContentsBlock>

                </MySettingWrapBlock>
                <Footer />
            </MySettingBlock>
        );
    }

    if (totalCount === 0) {
        return (
            <MySettingBlock>
                <Header />
                <MySettingWrapBlock>
                    <MySettingLnbBlock>
                        <h2>마이페이지</h2>
                        <MySettingLnbUlContainBlock>
                        <ul style = {isMobileOnly? {width:'max-content'}:{}}>
                            {
                                menuTitle.map((curitem, idx) => {
                                    return (
                                        <MySettingLnbLiBlock key={idx}>
                                            <HoverLinkBtn text={curitem.title}
                                                bottom="2px"
                                                height="4px"
                                                link={curitem.link}
                                                isDot={false}
                                                isUnderLine={curitem.isUnderLine}>
                                            </HoverLinkBtn>
                                        </MySettingLnbLiBlock>
                                    );
                                })
                            }
                        </ul>
                        </MySettingLnbUlContainBlock>
                    </MySettingLnbBlock>
                    <MyQuestionContentsBlock className="mypage-content">
                        <CustomTitleBlock marginBottom="58px" textColor="#333"
                            fontSize="24px" fontWeight="300" textAlign="left" >
                            <span style={{ fontWeight: '500' }}>1:1</span> 문의 내역
                        </CustomTitleBlock>
                        <MyQuestionNoItemBloc>
                            <MyQuestionNoItemSpanBlock style={{width:'fit-content'}}>
                                문의 내역이 없어요 :-(
                            </MyQuestionNoItemSpanBlock>
                        </MyQuestionNoItemBloc>
                        <MyQuestionButtonContainBlock>
                            <MyQuestionButtonBlock className="mh-btn black-btn" onClick={handleQuestion}>
                                1:1 문의하기
                                </MyQuestionButtonBlock>
                        </MyQuestionButtonContainBlock>
                    </MyQuestionContentsBlock>

                </MySettingWrapBlock>
                <Footer />
            </MySettingBlock>
        );
    }

    return (
        <MySettingBlock>
            <Header />
            <MySettingWrapBlock>
                <MySettingLnbBlock>
                    <h2>마이페이지</h2>
                    <MySettingLnbUlContainBlock>
                    <ul style = {isMobileOnly? {width:'max-content'}:{}}>
                        {
                            menuTitle.map((curitem, idx) => {
                                return (
                                    <MySettingLnbLiBlock key={idx}>
                                        <HoverLinkBtn text={curitem.title}
                                            bottom="2px"
                                            height="4px"
                                            link={curitem.link}
                                            isDot={false}
                                            isUnderLine={curitem.isUnderLine}>
                                        </HoverLinkBtn>
                                    </MySettingLnbLiBlock>
                                );
                            })
                        }
                    </ul>
                    </MySettingLnbUlContainBlock>
                </MySettingLnbBlock>
                <MyQuestionContentsBlock className="mypage-content">
                    <CustomTitleBlock marginBottom="58px" textColor="#333"
                        fontSize="24px" fontWeight="300" textAlign="left" >
                        <span style={{ fontWeight: '500' }}>1:1</span> 문의 내역
                        </CustomTitleBlock>
                    <MyQuestionAccoUlBlock className="qna-acco">
                        {

                            listData.dataList.map((dataInfo, index) => {

                                return <QuestionAccoItem key={dataInfo.id.toString()} dataInfo={dataInfo}
                                    clickHandler={handleAccBtn}
                                    active={dataInfo.id === curSelId} />
                            })
                        }
                    </MyQuestionAccoUlBlock>
                    <Pagination updatePageNum={handleChangePageNum} prodItems={listData} />
                    <MyQuestionButtonContainBlock>
                        <MyQuestionButtonBlock className="mh-btn black-btn" onClick={handleQuestion}>
                            1:1 문의하기
                        </MyQuestionButtonBlock>
                    </MyQuestionButtonContainBlock>
                </MyQuestionContentsBlock>

            </MySettingWrapBlock>
            <Footer />
        </MySettingBlock>
    );
};

export default MyQuestion;
